/**
 * Store for flags that control general app behaviour
 */
import { defineStore } from 'pinia';
import type { FilterCategoryTab } from '@/types/FilterCategoryTab';

export const useGeneralFlagStore = defineStore('generalFlagStore', {
  state: () => {
    return {
      showFilterMenu: false, //Show / hide filter menu in study list
      //Active category tab of the study list filter menu on mobile. Lives in
      //the store (not component-local) so the selection survives the remount
      //of the filter menu that follows every filter change.
      activeFilterCategoryTab: 'general' as FilterCategoryTab,
      showBriefTitles: true, //True: Show brief titles of studies in list; false: Show official titles
      showTableColumnSelection: false, //Whether to show menu for selecting columns to show in study list table
      studyFilterResetRequested: false,
      showBiomarkerSimpleFilterPopup: false,
      showCreateSubstanceModal: false,
      displayChangeHistory: false,
      readonlyMode: true, //details view: Readonly or edit mode
      creationMode: false,
      changeRequestMode: false,
      showGenericInfoModal: false,
      showTitleInfoModal: false,
      showGenericTextInputModal: false,
      filterProfileUpdateInProcess: false,
    };
  },
  getters: {},
  actions: {
    toggleChangeHistory() {
      this.displayChangeHistory = !this.displayChangeHistory;
    },

    toggleFilterMenu() {
      this.showFilterMenu = !this.showFilterMenu;
    },

    setActiveFilterCategoryTab(tab: FilterCategoryTab) {
      this.activeFilterCategoryTab = tab;
    },

    toggleBriefTitles() {
      this.showBriefTitles = !this.showBriefTitles;
    },

    toggleTableColumnSelection() {
      this.showTableColumnSelection = !this.showTableColumnSelection;
    },

    toggleChangeRequestMode() {
      this.changeRequestMode = !this.changeRequestMode;
    },

    requestFilterReset() {
      this.studyFilterResetRequested = true;
    },

    filterResetDone() {
      this.studyFilterResetRequested = false;
    },

    openBiomarkerSimpleFilterPopup() {
      this.showBiomarkerSimpleFilterPopup = true;
    },

    closeBiomarkerSimpleFilterPopup() {
      this.showBiomarkerSimpleFilterPopup = false;
    },

    closeSubstanceCreationModal() {
      this.showCreateSubstanceModal = false;
    },

    openSubstanceCreationModal() {
      this.showCreateSubstanceModal = true;
    },

    closeGenericInfoModal() {
      this.showGenericInfoModal = false;
    },

    openGenericInfoModal() {
      this.showGenericInfoModal = true;
    },

    openTitleInfoModal() {
      this.showTitleInfoModal = true;
    },

    closeTitleInfoModal() {
      this.showTitleInfoModal = false;
    },

    openGenericTextInputModal() {
      this.showGenericTextInputModal = true;
    },

    closeGenericTextInputModal() {
      this.showGenericTextInputModal = false;
    },
  },
});
